import { TReportData } from 'redux/reducers/hmrc/types';
import { TTableStructure, ETableStructureAlign, ETableStructureType } from 'ui/EasTable/types';

export const emReportsDetailStructure: TTableStructure<keyof TReportData>[] = [
	{
		name: 'ID',
		selector: 'id',
		show: false,
		sortable: true,
		filterable: false,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},

	{
		name: 'EM Full Name',
		selector: 'emFullName',
		show: true,
		searchable: true,
		sortable: true,
		filterable: false,
		type: ETableStructureType.EM,
		value: (item: TReportData) => {
			return { id: item?.emId, name: item.emFullName };
		},
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		name: 'BOX 1\nVAT Due Sales',
		selector: 'calculatedVatDueSales' as keyof TReportData,
		show: true,
		sortable: true,
		filterable: false,
		type: ETableStructureType.AMOUNT,
		currency: () => 'GBP',
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		name: 'BOX 2\nVAT Due Acquisitions',
		selector: 'calculatedVatDueAcquisitions' as keyof TReportData,
		show: true,
		sortable: true,
		filterable: false,
		type: ETableStructureType.AMOUNT,
		currency: () => 'GBP',
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		name: 'BOX 3\nTotal VAT Due',
		selector: 'calculatedTotalVatDue' as keyof TReportData,
		show: true,
		sortable: true,
		filterable: false,
		type: ETableStructureType.AMOUNT,
		currency: () => 'GBP',
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		name: 'BOX 4\nVAT Reclaimed Current Period',
		selector: 'calculatedVatReclaimedCurrPeriod' as keyof TReportData,
		show: true,
		sortable: true,
		filterable: false,
		type: ETableStructureType.AMOUNT,
		currency: () => 'GBP',
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		name: 'BOX 5\nNet VAT Due',
		selector: 'calculatedNetVatDue' as keyof TReportData,
		show: true,
		sortable: true,
		filterable: false,
		type: ETableStructureType.AMOUNT,
		currency: () => 'GBP',
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		name: 'BOX 6\nTotal Value Sales Ex VAT',
		selector: 'calculatedTotalValueSalesExVAT' as keyof TReportData,
		show: true,
		sortable: true,
		filterable: false,
		type: ETableStructureType.AMOUNT,
		currency: () => 'GBP',
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		name: 'BOX 7\nTotal Acquisitions Ex VAT',
		selector: 'calculatedTotalAcquisitionsExVAT' as keyof TReportData,
		show: true,
		sortable: true,
		filterable: false,
		type: ETableStructureType.AMOUNT,
		currency: () => 'GBP',
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},

	{
		name: 'BOX 8\nTotal Value Goods Supplied Ex VAT',
		selector: 'calculatedTotalValueGoodsSuppliedExVAT' as keyof TReportData,
		show: true,
		sortable: true,
		filterable: false,
		type: ETableStructureType.AMOUNT,
		currency: () => 'GBP',
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		name: 'BOX 9\nTotal Value Purchases Ex VAT',
		selector: 'calculatedTotalValuePurchasesExVAT' as keyof TReportData,
		show: true,
		sortable: true,
		filterable: false,
		type: ETableStructureType.AMOUNT,
		currency: () => 'GBP',
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},

	{
		name: 'Invoice Status',
		selector: 'invoiceStatus',
		show: true,
		sortable: true,
		filterable: false,
		type: ETableStructureType.STATUS,
		align: ETableStructureAlign.LEFT,
		filter: [
			['Paid', 'Paid'],
			['Pending', 'Pending'],
		],
		colors: [
			['Paid', 'success.light'],
			['Pending', 'error.light'],
		],
		colSpan: 1,
	},
];
